import React, { ReactNode, Suspense, useCallback } from 'react';

import { useTeamsClientContext } from '../../TeamsClientProvider/hooks';
import LoadableTeamsSubHeader from '../LoadableTeamsSubHeader';

type UseSubHeaderCallback = () => () => ReactNode;
export const useSubHeaderCallback: UseSubHeaderCallback = () => {
  const { shouldHideHeaders, shouldHideSubHeader } = useTeamsClientContext();

  return useCallback(
    () =>
      shouldHideHeaders || shouldHideSubHeader ? null : (
        <Suspense fallback={null}>
          <LoadableTeamsSubHeader />
        </Suspense>
      ),
    [shouldHideHeaders, shouldHideSubHeader]
  );
};
